module.exports = __webpack_public_path__ + "img/5.7b00725e.png";